<template>
  <div class="pricing-card-wrapper">
    <div v-if="plan.isPopular" class="popular-tag">
      {{ $t("pricing.popular") }}
    </div>
    <div
      :class="{ 'pricing-card--popular': plan.isPopular }"
      class="pricing-card"
    >
      <span class="text-sm font-bold">{{ $t(plan.type) }}</span>
      <div class="flex flex-col items-center justify-center gap-3">
        <span v-if="plan.price === null" class="text-[34px] font-semibold">
          {{ price }}
        </span>
        <div v-else class="flex flex-row items-end">
          <span class="pricing-card__price">${{ price }}</span>
          <span class="pricing-card__interval"> /{{ interval }} </span>
        </div>
        <span
          v-if="plan.type !== 'Enterprise'"
          class="pricing-card__interval"
          >{{ billingInterval }}</span
        >
      </div>
      <span class="text-xs font-semibold">{{ $t(plan.description) }}</span>
      <div class="flex flex-col w-full justify-center gap-4">
        <div
          v-for="(detail, index) in plan.details"
          :key="index"
          class="flex flex-row w-full items-center justify-start gap-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M3.16895 5.90733L5.44151 8.1799L9.98665 3.63477"
              stroke="#2B5DE5"
              stroke-width="1.275"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="text-xs font-medium">{{ $t(detail) }}</span>
        </div>
      </div>
      <Button
        class="primary h-[42px] w-[200px] text-xs font-bold"
        @click="upgrade"
      >
        {{ $t("button.pricing.contact") }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  name: "PricingCard",
  components: { Button },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    isAnnual: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    upgrade() {
      this.$emit("upgrade");
    },
  },
  computed: {
    price() {
      return this.plan.price !== null
        ? this.isAnnual
          ? Math.round(
              (this.plan.price * (100 - this.plan.annualDiscount)) / 100
            )
          : this.plan.price
        : this.$t("pricing.plans.contact_us");
    },
    interval() {
      return this.plan.type === this.$t("pricing.plans.unlimited")
        ? this.$t("pricing.period.month")
        : `5 ${this.$t("pricing.period.users_month")}`;
    },
    billingInterval() {
      return this.isAnnual
        ? `(${this.$t("pricing.period.billed_annually")})`
        : `(${this.$t("pricing.period.billed_monthly")})`;
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
